export default __webpack_public_path__ + "static/media/dell.cd0d1034.png";